import type { Theme } from '../../types/theme';

export const opencodeTheme: Theme = {
  id: 'opencode',
  name: 'OpenCode AI',
  description: 'Developer-centric dark theme for AI coding platform',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/opencode-ai/DESIGN.md',
  visualKeywords: ['dark', 'indigo accent', 'coding', 'developer', 'minimal'],
  colors: {
    background: '#0f0f0f',
    surface: '#1a1a1a',
    surfaceElevated: '#242424',
    textPrimary: '#ffffff',
    textSecondary: '#a0a0a0',
    textMuted: '#a0a0a0',
    border: '#2a2a2a',
    borderSubtle: '#343434',
    primary: '#6366f1',
    primaryHover: '#7275ff',
    primaryActive: '#4548d3',
    accent: '#6366f1',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'technical',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
